import { getPendingDataRequestCount } from '@/api/DataRequestApi';
import { onUserEvent } from '@/hooks/useWebsockets';

export function usePendingDataRequestCount(): ComputedRef<number> {
  const count = ref<number>(0);

  onUserEvent('pending-data-request-count-updated', refreshCount);

  onMounted(refreshCount);

  async function refreshCount() {
    count.value = await getPendingDataRequestCount().then(
      (data) => data.pending_data_request_count
    );
  }

  return computed(() => count.value);
}
